<template>
    <Layout :title="campaign.data.name">
    
        <div to="modal">
            <transition enter-active-class="transition duration-300 ease-out transform"
                enter-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
                leave-active-class="transition duration-100 ease-in" leave-class="opacity-100"
                leave-to-class="opacity-0">
                <modal v-if="flash.success" title="Succes" :message="flash.success"></modal>
            </transition>
        </div>

        <div class="mt-4 ml-8 mr-8">
            <h3 class="text-lg font-medium leading-6 text-gray-600">Campagne Overzicht</h3>
            <dl class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
                <a v-if="is('BCSA')" :href="'/organisations/' + campaign.data.organisationId + ''">
                    <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6 hover:bg-gray-300 ">
                        <dt class="truncate text-sm font-medium text-gray-500">Organisatie</dt>
                        <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-600">{{ campaign.data.name }}</dd>
                    </div>
                </a>
                <a v-if="is('Customer')" href="/organisation">
                    <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6 hover:bg-gray-300 ">
                        <dt class="truncate text-sm font-medium text-gray-500">Organisatie</dt>
                        <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-600">{{ campaign.data.name }}</dd>
                    </div>
                </a>
                <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
                    <dt class="truncate text-sm font-medium text-gray-500">Deelnemers</dt>
                    <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-600">{{
                            campaign.data.attendees_amount
                    }}</dd>
                </div>
                <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
                    <dt class="truncate text-sm font-medium text-gray-500">Pogingen per deelnemer</dt>
                    <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-600">{{
                            campaign.data.attempts_per_user
                    }}</dd>
                </div>
                <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
                    <dt class="truncate text-sm font-medium text-gray-500">Startdatum</dt>
                    <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-600">{{ campaign.data.starting_at }}&nbsp;&nbsp;&nbsp;{{ campaign.data.starting_time }}
                    </dd>
                </div>
                <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
                    <dt class="truncate text-sm font-medium text-gray-500">Einddatum</dt>
                    <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-600">{{ campaign.data.finished_at }}&nbsp;&nbsp;&nbsp;{{ campaign.data.finished_time }}
                    </dd>
                </div>
                <a :href="'/schedule/' + campaign.data.id + ''">
                    <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6 hover:bg-gray-300">
                        <dt class="truncate text-sm font-medium text-gray-500">Geplande Pogingen</dt>
                        <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-600">{{
                                campaign.data.scheduledAmount
                        }}</dd>
                    </div>
                </a>        
            </dl>
        </div>

        
        <div class="mt-4 ml-8 mr-8">
            <dl class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-1">
                <a :href="'/attempts/' + campaign.data.id + ''">
                    <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6 hover:bg-gray-300">
                        <dt class="truncate text-sm font-medium text-gray-500">Verstuurde Pogingen</dt>
                        <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-600">{{
                                campaign.data.attemptsAmount
                        }}</dd>
                    </div>
                </a>
            </dl>
            <dl class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
                <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
                    <dt class="truncate text-sm font-medium text-gray-500">Type</dt>
                    <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-600">Geopend</dd>
                </div>
                <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
                    <dt class="truncate text-sm font-medium text-gray-500">Aantal geopende mails</dt>
                    <dd class="mt-1 text-3xl font-semibold tracking-tight text-red-600"
                    :class="{ 'text-green-600': campaign.data.openenedMailsAmount == 0 }">{{ campaign.data.openenedMailsAmount }}</dd>
                </div>
                <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
                    <dt class="truncate text-sm font-medium text-gray-500">Percentage geopende mails</dt>
                    <dd class="mt-1 text-3xl font-semibold tracking-tight text-red-600"
                    :class="{ 'text-green-600': campaign.data.openenedMailsAmount == 0 }">{{ campaign.data.openenedMailsPercentage }}%</dd>
                </div>
    <!-- -------------------------------------------------------- -->
                <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
                    <dt class="truncate text-sm font-medium text-gray-500">Type</dt>
                    <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-600">Links</dd>
                </div>
                <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
                    <dt class="truncate text-sm font-medium text-gray-500">Aantal geklikte links</dt>
                    <dd class="mt-1 text-3xl font-semibold tracking-tight text-red-600"
                        :class="{ 'text-green-600': campaign.data.failedUsersAmount == 0 }"
                    >{{ campaign.data.failedUsersAmount }}</dd>
                </div>
                <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
                    <dt class="truncate text-sm font-medium text-gray-500">Percentage geklikte links</dt>
                    <dd class="mt-1 text-3xl font-semibold tracking-tight text-red-600"
                    :class="{ 'text-green-600': campaign.data.failedUsersAmount == 0 }"
                    >{{ campaign.data.failedUsersPercentage }}%</dd>
                </div>
    <!-- -------------------------------------------------------- -->
                <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
                    <dt class="truncate text-sm font-medium text-gray-500">Type</dt>
                    <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-600">Bestanden</dd>
                </div>
                <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
                    <dt class="truncate text-sm font-medium text-gray-500">Geopend aantal bestanden</dt>
                    <dd class="mt-1 text-3xl font-semibold tracking-tight text-red-600"
                    :class="{ 'text-green-600': campaign.data.openenedFilesAmount == 0 }">{{ campaign.data.openenedFilesAmount }}</dd>
                </div>
                <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
                    <dt class="truncate text-sm font-medium text-gray-500">Percentage geopende bestanden</dt>
                    <dd class="mt-1 text-3xl font-semibold tracking-tight text-red-600"
                    :class="{ 'text-green-600': campaign.data.openenedFilesAmount == 0 }">{{ campaign.data.openenedFilesPercentage }}%</dd>
                </div>
    <!-- -------------------------------------------------------- -->
                <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
                    <dt class="truncate text-sm font-medium text-gray-500">Type</dt>
                    <dd class="mt-1 text-3xl font-semibold tracking-tight text-gray-600">Data</dd>
                </div>
                <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
                    <dt class="truncate text-sm font-medium text-gray-500">Aantal keer data ingevuld</dt>
                    <dd class="mt-1 text-3xl font-semibold tracking-tight text-red-600"
                    :class="{ 'text-green-600': campaign.data.dataEnteredAmount == 0 }">{{ campaign.data.dataEnteredAmount }}</dd>
                </div>
                <div class="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
                    <dt class="truncate text-sm font-medium text-gray-500">Percentage data ingevuld</dt>
                    <dd class="mt-1 text-3xl font-semibold tracking-tight text-red-600"
                    :class="{ 'text-green-600': campaign.data.dataEnteredAmount == 0 }">{{ campaign.data.dataEnteredPercentage }}%</dd>
                </div>
            </dl>
        </div>

        <div id="Buttons" class="mt-4 ml-8 mr-8 flex" >
            <div>
                <button v-if="is('BCSA')" class="rounded-md border p-2 bg-white shadow hover:border-black text-gray-600" type="button" @click="sendAll()">Stuur alle geplande pogingen</button>
                <a :href="'/export/' + campaign.data.id">
                    <button class="rounded-md border p-2 bg-white shadow hover:border-black text-gray-600" type="button">Download export</button>
                </a>
            </div>
            <div v-if="is('BCSA')" class="ml-auto">    
                <button class="rounded-md border p-2 text-red-600 bg-white shadow hover:border-red-600" type="button" @click="stopCampaign()">Stop campagne</button>
                <button class="rounded-md border p-2 text-red-600 bg-white shadow hover:border-red-600" type="button" @click="deleteCampaign()">Verwijder campagne</button>
            </div>
        </div>
     
    </Layout>
</template>

<script>
import Layout from '../../Shared/Layout';
import Modal from '@/Shared/Modal';

export default {
    components: {
        Layout,
        Modal,
    },
    props: {
        campaign: Object,
        success: String,
        flash: Object,
    },
    data: () => ({
        form: {
        }
        
    }),
    methods: {
        stopCampaign(){
            if(window.confirm('Weet je zeker dat je deze campagne wilt stoppen?') == true){

                this.form = this.$props.campaign.data;
                this.$inertia.post('/campaign/stop', this.form);

            } else {
                console.log('nee');
            }
        },
        deleteCampaign(){
            if(window.confirm('Weet je zeker dat je deze campagne wilt verwijderen?') == true){

                this.form = this.$props.campaign.data;
                this.$inertia.delete('/campaign/' + this.form.id);
            } else {
                console.log('nee');
            }
        },
        sendAll(){
            if(window.confirm('Weet je zeker dat je alle geplande mails wilt versturen?') == true){
                
                this.form = this.$props.campaign.data;
                this.$inertia.post('/campaign/send', this.form);

            } else {
                console.log('nee');
            }
        },
    }

}

</script>